import { EmailValidationResult, type InviteFormContact } from "../types";

const VALID_EMAIL_VALIDATION_RESULTS = [
  null, // Validation result is null if email is validated but no error/info message necessary
  EmailValidationResult.VALID_EMAIL,
  EmailValidationResult.VALID_EMAIL_NET_NEW_USER,
  EmailValidationResult.VALID_EMAIL_WORK_USER_FROM_DIFFERENT_TEAM,
  EmailValidationResult.VALID_EMAIL_TEAM_MEMBER_WITHOUT_DASH,
] as const;

type ValidEmailValidationResult =
  (typeof VALID_EMAIL_VALIDATION_RESULTS)[number];

/**
 * TODO: For now we consider a contact with an unvalidated email as invalid
 *  when calculating license usage and validating forms. The assumption is that
 *   all emails should be validated soon after being added. Revisit this once
 *   we have clearer requirements
 */
export const isValidInvitee = <T extends InviteFormContact>(
  contact: T,
): contact is T & {
  email: string;
  validationResult: ValidEmailValidationResult;
} => {
  if (!contact.email || contact.validationResult === undefined) {
    return false;
  }

  return VALID_EMAIL_VALIDATION_RESULTS.some(
    (validEmailValidationResult) =>
      validEmailValidationResult === contact.validationResult,
  );
};
